import { default as deserialize } from 'app/utils/deserialize'
import { fetch } from 'app/utils/data'

export default {
  namespaced: true,

  state: {
    item: {
      account: { id: 0 }
    },
    topBandwidth: []
  },

  getters: {
    currentToken: (state) => state.item,
    currentTopBandwidth: (state) => state.topBandwidth
  },

  mutations: {
    tokenFetched(state, { token }) {
      state.item = token
    },

    topBandwidthFetched(state, { topBandwidth }) {
      state.topBandwidth = topBandwidth
    }
  },

  actions: {
    async fetchToken({ commit }, tokenId) {
      const response = await fetch({ url: `/api/admin/tokens/${tokenId}` })

      const token = await deserialize(response.data)

      commit('tokenFetched', { token })
    },

    async fetchTopBandwidth({ commit }) {
      const response = await fetch({ url: '/api/admin/top/bandwidth' })

      const topBandwidth = await deserialize(response.data)

      commit('topBandwidthFetched', { topBandwidth })
    }
  }
}
